import { Observable } from 'rxjs';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivate, Router, CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Injectable()

export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
    if (!route.component){
      this.authService.saveAdminAction('navigated', state.url);
    }
    return this.authService.isAuthenticated();
  }
}

